import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import IconQuote from 'components/icons/iconQuote';
const CustomerQuote = t0 => {
  const $ = _c(10);
  const {
    children,
    showQuoteMark: t1,
    size: t2,
    variant
  } = t0;
  const showQuoteMark = t1 === undefined ? true : t1;
  const size = t2 === undefined ? "md" : t2;
  const t3 = size === "sm";
  const t4 = size === "md";
  const t5 = variant === "InspirationPage";
  let t6;
  if ($[0] !== t3 || $[1] !== t4 || $[2] !== t5) {
    t6 = classNames("text-gray relative", "[&_svg]:absolute [&_svg]:top-[-9px] [&_svg]:left-0 [&_svg]:z-[-1]", "[&_svg_path]:fill-gray-light8", {
      "text-sm mt-4 mx-0 mb-8": t3,
      "text-base md:text-lg mt-2 mx-0 mb-6": t4,
      "max-[767px]:m-0": t5
    });
    $[0] = t3;
    $[1] = t4;
    $[2] = t5;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t7;
  if ($[4] !== showQuoteMark) {
    t7 = showQuoteMark && <IconQuote />;
    $[4] = showQuoteMark;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] !== children || $[7] !== t6 || $[8] !== t7) {
    t8 = <p className={t6}>{t7}{children}</p>;
    $[6] = children;
    $[7] = t6;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  return t8;
};
CustomerQuote.propTypes = {
  children: PropTypes.node,
  showQuoteMark: PropTypes.bool,
  size: PropTypes.oneOf(['sm', 'md']),
  variant: PropTypes.oneOf(['InspirationPage'])
};
export default CustomerQuote;